/**
 * One avatar per distinct commenter, in first-comment order.
 * Sparse comments (missing author) are skipped; a missing list is treated as empty.
 */
export function collectThreadParticipants(comments = []) {
  const seen = new Map();
  comments.forEach((comment) => {
    const author = comment?.author;
    if (!author || seen.has(author)) return;
    seen.set(author, { author, initials: comment.initials });
  });
  return Array.from(seen.values());
}
